<template>
    <auth-card-template>
        <card-auth>
            <div v-show="isLoadingVerification">
                <h4 class="font-family-title font-weight-bold text-success text-center mb-6">Verificação de e-mail</h4>

                <div class="text-center text-lg mb-6">
                    <p>
                        Por favor, aguarde um momento enquanto estamos validando o seu e-mail.
                    </p>
                    <text-loading text="Processando" />
                </div>
            </div>

            <div v-show="isVerificationInvalid">
                <h4 class="font-weight-bold text-danger text-center mb-6">O link de verificação é inválido</h4>

                <div class="text-center text-lg mb-6">
                    <p class="mb-2">
                        <strong>Qual a causa deste problema?</strong>
                    </p>
                    <p class="mb-0">
                        Provavelmente este link de verificação já foi utilizado ou ele possui um ID inválido. Se precisar
                        de ajuda basta entrar em contato com o nosso suporte.
                    </p>
                </div>

                <div class="text-center">
                    <router-link to="/auth/login" class="text-lg font-weight-semibold">Voltar para o login</router-link>
                </div>
            </div>

            <template v-if="isVerificationSuccess">
                <h4 class="font-family-title font-weight-bold text-success text-center mb-6">Seu cadastro foi confirmado!</h4>

                <p class="text-center text-lg mb-6">
                    Agora você pode acessar sua conta com o e-mail<br>
                    <span class="font-weight-semibold">{{ userEmail }}</span>
                </p>

                <div class="text-center">
                    <router-link :to="{ path: '/auth/login', query: { email: userEmail }}" class="btn btn-success btn-lg">Fazer login</router-link>
                </div>
            </template>
        </card-auth>
    </auth-card-template>
</template>

<script>
    import TextLoading      from '@/components/atoms/TextLoading'
    import CardAuth         from '@/components/organisms/CardAuth'
    import AuthCardTemplate from '@/components/templates/AuthCardTemplate'

    export default {
        components: {
            TextLoading,
            CardAuth,
            AuthCardTemplate
        },
        data() {
            return {
                verificationId: '',
                userEmail: '',
                isLoadingVerification: true,
                isVerificationInvalid: false,
                isVerificationSuccess: false
            }
        },
        beforeRouteEnter(to, from, next)
        {
            if (to.query.id) {
                next(vm => { vm.verificationId = to.query.id; });
            }
            else {
                next('/auth/login');
            }
        },
        mounted()
        {
            this.$nextTick(() => {
                setTimeout(() => { this.verify(); }, 2000)
            });
        },
        methods: {
            /**
             * Verificar e-mail de cadastro usando o ID enviado.
             */
            verify()
            {
                this.isLoadingVerification = true;

                this.$api.post('/login/verify', { id: this.verificationId })
                    .then (response => {
                        this.userEmail = response.data.data.email;
                        this.isLoadingVerification = false;
                        this.isVerificationSuccess = true;

                        // Tag de conversão do Facebook
                        if (typeof window.fbq !== "undefined") {
                            fbq('track', 'CompleteRegistration', {value: 0.00, currency: 'BRL'});
                        }

                        // Tag de conversão do Google Ads
                        if (typeof window.gtag !== 'undefined') {
                            gtag('event', 'conversion', {'send_to': 'AW-798302531/yEPFCOzPgcQBEMPC1PwC'});
                        }

                        // Tag do GA4
                        if (typeof window.gtag !== 'undefined' && typeof window.GA4_MEASUREMENT_ID !== 'undefined') {
                            gtag('event', 'form_email', { 'send_to': window.GA4_MEASUREMENT_ID });
                        }
                    })
                    .catch(error => {
                        const isInvalid = typeof error.response.data.data.invalid !== 'undefined' ? error.response.data.data.invalid : false;

                        if (isInvalid) {
                            this.isLoadingVerification = false;
                            this.isVerificationInvalid = true;
                        }
                        else {
                            alert('Desculpe, ocorreu um erro ao tentar processar a sua solicitação.');
                            window.location.href = '/auth/login';
                        }
                    })
            }
        }
    }
</script>

<style scoped>

</style>